$(function () {
    var knappar = $('.js-valj-bransch');
    var beskrivning = $('.bransch-beskrivning');
    var startBeskrivning = $('.js-valj-bransch.selected');

    if (!knappar.length || !beskrivning.length) {
        return;
    }

    if (startBeskrivning.length) {
        beskrivning.text($(startBeskrivning).data('description'));
    }

    knappar.on('click', function () {
        var knapp = $(this);
        var id = knapp.data('id');
        knappar.removeClass('selected');
        knapp.addClass('selected');
        beskrivning.text(knapp.data('description'));
        $('[id^="bransch-"]').addClass('hidden');
        $('#bransch-' + id).removeClass('hidden');
    });
});
